import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import type { StaffRole } from '@/types/api.types';

interface Props {
  children: React.ReactNode;
  roles?: StaffRole[];
}

export function AuthGuard({ children, roles }: Props) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && user && user.role !== 'ADMIN' && !roles.includes(user.role)) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <>{children}</>;
}
